import res from './res'

res.add('kk', {
    title: 'Бөлім әзірлеуде',
    description: 'Біздің мамандар жұмыс істейді, көп ұзамай бәрі жұмыс істейді'
})
